import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonBoxDecide,
  Heading,
  BaseText,
  Row,
  InitialAvatarIcon,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import type { ProfitOptions } from '@/modules/trade/services/profit';
import { useRouter } from 'vue-router/composables';

interface Props {
  profitOptions: ProfitOptions;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitSubscriptionContent',
  props: {
    profitOptions: null
  },
  setup(__props: any) {

const props = __props as {
  profitOptions: ProfitOptions;
};


const router = useRouter();

function goToProfitPreview(profitValue: number) {
  const profitValueAsIdentifier = profitValue.toString();
  router.push({
    name: 'profitPreview',
    params: { profit: profitValueAsIdentifier }
  });
}

function goToProfitCancellation() {
  router.push({ name: 'profitCancellation' });
}

function setButtonStyle(observation: string) {
  const activeButton = /Ativo/.test(observation)
    ? 'profit-subscription__button-box--active'
    : '';
  return `profit-subscription__button-box ${activeButton}`;
}

return { __sfc: true,props, router, goToProfitPreview, goToProfitCancellation, setButtonStyle, ButtonBoxDecide, Heading, BaseText, Row, InitialAvatarIcon, ButtonPrimary, ButtonSecondary }
}

})